import { cn } from '../cn';
import { ICONS, type IconName } from '../icons';

import type { SVGProps } from 'react';

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name' | 'color' | 'ref'> {
  /** Lucide kebab-case name, as in the design files (`arrow-left`). */
  name: IconName;
  /** Width and height in px. */
  size?: number | undefined;
  /** Any CSS colour, usually a token: `var(--content-subdued)`. Defaults to the text colour. */
  color?: string | undefined;
  strokeWidth?: number | undefined;
}

/** Decorative by default (aria-hidden). Pass `aria-label` and `role="img"` for a meaningful icon. */
export function Icon({
  name,
  size = 20,
  color = 'currentColor',
  strokeWidth = 2,
  className,
  ...rest
}: IconProps) {
  const Glyph = ICONS[name];
  return (
    <Glyph
      aria-hidden={rest['aria-label'] ? undefined : true}
      focusable="false"
      width={size}
      height={size}
      color={color}
      strokeWidth={strokeWidth}
      className={cn('shrink-0', className)}
      {...rest}
    />
  );
}
